// extracted by css-extract-rspack-plugin
export default {"formSubmitButton":"_d97c9501"};